module.exports = __webpack_public_path__ + "static/media/branding-img19.eb9fe9cd.jpg";